// invoice http service

import { api } from './api.config'

import request from '@/utils/request'

export default {
  customer: {
    list (data) {
      return request({
        url: api.customer.list,
        method: 'get',
        data
      })
    },
    detail (data) {
      return request({
        url: api.customer.detail,
        method: 'get',
        data
      })
    },
    delete (data) {
      return request({
        url: api.customer.delete,
        method: 'delete',
        data
      })
    }
  },
  address: {
    addOrEdit (data) {
      return request({
        url: api.address.addOrEdit,
        method: 'post',
        data
      })
    },
    getAddressDetail (data) {
      return request({
        url: api.address.getAddressDetail,
        method: 'get',
        data
      })
    }
  },
  smart: {
    smartTitle (data) {
      return request({
        url: api.smart.smartTitle,
        method: 'get',
        data
      })
    }
  },
  wechat: {
    getOffiaccountSignature (data) {
      return request({
        url: api.wechat.getOffiaccountSignature,
        method: 'get',
        data
      })
    }
  },
  noteLookProof: {
    getProofInfo (data) {
      return request({
        url: api.noteLookProof.getProofInfo,
        method: 'get',
        data
      })
    },
    sendEmail (data) {
      return request({
        url: api.noteLookProof.sendEmail,
        method: 'get',
        data
      })
    },
    getPdfUrl (data) {
      return request({
        url: api.noteLookProof.getPdfUrl,
        method: 'get',
        data
      })
    }
  },
  extendField: {
    getExtendFieldList (data) {
      return request({
        url: api.extendField.getExtendFieldList,
        method: 'post',
        data
      })
    },
    setExtendField (data) {
      return request({
        url: api.extendField.setExtendField,
        method: 'post',
        data
      })
    },
    getExtendField (data) {
      return request({
        url: api.extendField.getExtendField,
        method: 'post',
        data
      })
    },
    getNotAuthExtendField (data) {
      return request({
        url: api.extendField.getNotAuthExtendField,
        method: 'post',
        data
      })
    },
    resetConfig (data) {
      return request({
        url: api.extendField.resetConfig,
        method: 'post',
        data
      })
    },
    setWaitExtendById (data) {
      return request({
        url: api.extendField.setWaitExtendById,
        method: 'post',
        data,
        allParams: true
      })
    },
    setOutputExtendById (data) {
      return request({
        url: api.extendField.setOutputExtendById,
        method: 'post',
        data,
        allParams: true
      })
    },
    setEntryExtendById (data) {
      return request({
        url: api.extendField.setEntryExtendById,
        method: 'post',
        data,
        allParams: true
      })
    },
    setEntryNoExtendById (data) {
      return request({
        url: api.extendField.setEntryNoExtendById,
        method: 'post',
        data,
        allParams: true
      })
    },
    setAbnormalInvoiceById (data) {
      return request({
        url: api.extendField.setAbnormalInvoiceById,
        method: 'post',
        data,
        allParams: true
      })
    }
  }
}
